import React, { Component } from 'react';
import queryString from "query-string";
import Axios from 'axios';
import Helmet from 'react-helmet';
import { Link } from "react-router-dom";
import ReactTooltip from 'react-tooltip';


// utils
import SviChartMap from '../SviChartMap';
import SviChartTable from '../SviChartTable';
import CustomSelect from '../../utils/CustomSelect';
import CustomDropdown from '../../utils/CustomDropdown';
import CustomCheckbox from '../../utils/CustomCheckbox';
import SocialBlock from '../../utils/SocialBlock';
import chartCapture from '../../utils/Shared/chartCapture';
import LimitMask from '../../utils/LimitMask';
import LoadingDots from '../../utils/LoadingDots';

// methods                                                 
import gaTracking from '../../utils/Shared/gaTracking';
import { apiHost, loginApiHost, sourceHost } from '../../utils/Shared/constant';
import { loginRedirect, downloadTrigger, urlPushState } from '../../utils/Shared/methods';
import capture from '../../utils/Shared/chartCapture';
import svgMapCapture, { hasSvgMap } from '../../utils/Shared/svgMapCapture';
import { element } from 'prop-types';

// rsuite
import { TagPicker, Tag, Toggle, Animation } from 'rsuite';
import ArrowDownLineIcon from '@rsuite/icons/ArrowDownLine';
import CloseIcon from '@rsuite/icons/Close';
// import "rsuite/dist/rsuite.css";
import "rsuite/TagPicker/styles/index.css";
import "rsuite/Tag/styles/index.css";
import "rsuite/Toggle/styles/index.css";
import "rsuite/Toggle/styles/index.css";
// import { isValid } from 'rsuite/esm/utils/dateUtils';


// slick
import StorySlider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import iconCaseStory from '../../../images/icon-case-story.svg';

import './index.scss';

function StorySliderPrevButton(props) {
	const { className, style, onClick } = props;
	return (
		<button
			type="button"
			className={className}
			style={style}
			onClick={onClick}
			aria-label="上一組"
		>
			<i className="icon-arrow-left" aria-hidden="true" />
		</button>
	);
}

function StorySliderNextButton(props) {
	const { className, style, onClick } = props;
	return (
		<button
			type="button"
			className={className}
			style={style}
			onClick={onClick}
			aria-label="下一組"
		>
			<i className="icon-arrow-right" aria-hidden="true" />
		</button>
	);
}

const storySliderSettings = {
	dots: true,
	infinite: false,
	speed: 500,
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: true,
	prevArrow: <StorySliderPrevButton />,
	nextArrow: <StorySliderNextButton />,
};

class SviChart extends Component {
	constructor(params) {
		super(params);
		this.state = {
			type: 'z',
			isMemberLogin: false,
			availableYears: null,
			availableIndicators: [],
			categoryDescription: null,
			allIndicators: [],
			currentYear: '0',
			selectedCounty: null,
			resultCounty: null,
			currentIndicatorId: '0',
			currentIndicatorName: '',
			currentIndicatorDescription: '',
			isChartShow: false,
			isBasicLoading: false,
			isAdvanceLoading: false,
			isDataLoaded: false,
			countiesData: null,
			csvData: null,
			originCsvData: null,
			//測試
			isValid: false,
			selectedAvailableIndicators: [[], [], [], []],
			availableIndicatorsValue: [[], [], [], []],
			availableIndicatorsValueItems: [[], [], [], []],
			availableIndicatorsValueItemsPlus: [[], [], [], []],
			categoryToggle: [false, false, false, false],
			availableIndicatorsData: [],
			selectedCountyTmp: null,
			currentYearTmp: '0',
			selectedCountyCode: '', // 新增：追蹤選擇的行政區代碼
			isING: false,
			isShowCollapse: [true, true, true, true, true],
			markerToggle: [false, false, false, false],
			tableCollapseToggle: false,
			showOpt: false,
			isRestoringFromSession: false, // 標記是否正在從 sessionStorage 恢復狀態
			activePillCategoryIndex: null, // null = 不顯示 pill 列；0~3 = 顯示對應分類的 pills
			activePillId: null, // 目前選取的 indicator pill id；null = 該分類整體（categoryToggle）
			caseStories: [], // 下方案例故事輪播資料（依當前指標查詢狀態載入）
			caseStorySliderKey: 0,    // 案例故事輪播 remount key（每次 loadCaseStories 更新就 bump → 回到第一篇）
		};
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		this.props.onLoadHeaderColor('BLUE');
		this.props.onLoadHeaderTheme('DARK');
		this.props.onLoadShowLanguage('HIDE');
		const breadcrumb = [
			{ name: '首頁', href: '/' },
			{ name: '社會脆弱度評估', href: '/evaluation/svi' },
			{ name: '社會脆弱度指標查詢與展示', href: '/evaluation/svi/z' },
		]
		this.props.onLoadShowBreadcrumb('SHOW', breadcrumb);

		this.checkMemberLogin();

		// 檢查是否有儲存的查詢狀態
		const hasSavedState = sessionStorage.getItem('svi_z_query_state');
		const urlReport = queryString.parse(window.location.search);
		const hasUrlQuery = !!(urlReport.county && urlReport.year);

		this.getQuery();
		this.getCategoryDescription();
		this.getAvailableYears().then(() => {
			if (hasSavedState) {
				// 有儲存狀態，直接恢復
				this.restoreQueryStateFromSession();
			} else if (!hasUrlQuery) {
				// 全新進入：自動帶最新年度 + 全臺 + 全選指標並查詢
				this.autoLoadDefaultQuery();
			}
		});
		this.getAllIndicators();
		// this.getCountiesData();
		this.initLayout();
		this.loadCaseStories();
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.currentIndicatorId !== this.state.currentIndicatorId) {
			this.loadCaseStories();
		}
	}

	// 依當前指標查詢狀態撈案例故事：
	//   綜合 (0) → 全部，排序：L3 已選 → L3 未選 → L2 → L1 → L0
	//   四分類 (1~4) → 該分類的文章，排序 level 1→2→3
	//   單一指標 → 只撈該 indicator_id（後端過濾）
	// 最多 20 篇交給輪播顯示
	loadCaseStories = () => {
		const id = this.state.currentIndicatorId;
		const idNum = Number(id);
		let request;
		let getRank;
		if (idNum === 0) {
			request = Axios.get(`${apiHost}/api/Content/AvailableCaseStoryList?CurrentPage=1&PerPage=0`);
			const selectedIds = new Set(this.state.availableIndicatorsValue.flat());
			getRank = (a) => {
				const lv = a.IndicatorLevel == null ? 0 : a.IndicatorLevel;
				if (lv === 3) return selectedIds.has(a.IndicatorId) ? 0 : 1;
				if (lv === 2) return 2;
				if (lv === 1) return 3;
				return 4;
			};
		} else if (idNum >= 1 && idNum <= 4) {
			request = Axios.get(`${apiHost}/api/Content/AvailableCaseStoryListByCategory?categoryId=${idNum}&currentPage=1&perPage=0`);
			const priorityLevels = [1, 2, 3];
			getRank = (a) => {
				const lv = a.IndicatorLevel == null ? 0 : a.IndicatorLevel;
				const r = priorityLevels.indexOf(lv);
				return r === -1 ? Infinity : r;
			};
		} else {
			request = Axios.get(`${apiHost}/api/Content/AvailableCaseStoryList?CurrentPage=1&PerPage=0&IndicatorIds=${idNum}`);
			const priorityLevels = [3];
			getRank = (a) => {
				const lv = a.IndicatorLevel == null ? 0 : a.IndicatorLevel;
				const r = priorityLevels.indexOf(lv);
				return r === -1 ? Infinity : r;
			};
		}
		request
			.then(res => {
				const list = (res.data && res.data.Result) || [];
				const withRank = list
					.map((a, idx) => ({ a, idx, rank: getRank(a) }))
					.filter(x => Number.isFinite(x.rank))
					.sort((x, y) => x.rank - y.rank || x.idx - y.idx)
					.slice(0, 20)
					.map(x => x.a);
				this.setState(prev => ({ caseStories: withRank, caseStorySliderKey: prev.caseStorySliderKey + 1 }));
			})
			.catch(err => {
				console.error('loadCaseStories failed:', err);
				this.setState(prev => ({ caseStories: [], caseStorySliderKey: prev.caseStorySliderKey + 1 }));
			});
	}

	checkMemberLogin = () => {
		if (window.localStorage.getItem('user-token')) {
			this.setState({ isMemberLogin: true });
		}
	}
	restoreQueryStateFromSession = () => {
		const savedState = sessionStorage.getItem('svi_z_query_state');
		if (savedState) {
			try {
				const state = JSON.parse(savedState);

				// 先儲存需要在查詢後恢復的狀態
				this.pendingRestoreState = {
					availableIndicatorsValue: state.availableIndicatorsValue,
					csvData: state.csvData,
					originCsvData: state.originCsvData,
					resultData: state.resultData,
					availableIndicatorsData: state.availableIndicatorsData,
					availableIndicatorsValueItems: state.availableIndicatorsValueItems,
					isDataLoaded: state.isDataLoaded,
					currentIndicatorName: state.currentIndicatorName,
					currentIndicatorDescription: state.currentIndicatorDescription,
					categoryToggle: state.categoryToggle || [false, false, false, false],
					currentIndicatorId: state.currentIndicatorId || '0',
					activePillCategoryIndex: state.activePillCategoryIndex != null ? state.activePillCategoryIndex : null,
					activePillId: state.activePillId != null ? state.activePillId : null,
				};

				// 先恢復年份並獲取縣市列表
				this.setState({
					currentYearTmp: state.currentYearTmp,
					isRestoringFromSession: true,
				}, () => {
					// 先獲取縣市列表，等待完成後再恢復縣市選擇
					this.getCountiesData(state.currentYearTmp).then(() => {
						// 然後恢復縣市選擇和查詢 availableIndicators
						this.setState({
							selectedCountyTmp: state.selectedCountyTmp,
							selectedCountyCode: state.selectedCountyCode,
						}, () => {
							// 清除已使用的 session storage
							sessionStorage.removeItem('svi_z_query_state');
							// 重新執行查詢以取得 availableIndicators
							this.getAvailableIndicators();
						});
					});
				});
			} catch (error) {
				console.error('恢復查詢狀態失敗:', error);
				sessionStorage.removeItem('svi_z_query_state');
				this.setState({ isRestoringFromSession: false });
			}
		}
	}
	autoLoadDefaultQuery = async () => {
		if (this.autoLoadFired) return;
		this.autoLoadFired = true;

		const { availableYears } = this.state;
		if (!availableYears || availableYears.length === 0) return;

		const latestYear = availableYears[0];

		await new Promise(resolve => {
			this.setState({ currentYearTmp: latestYear }, resolve);
		});

		await this.getCountiesData(latestYear);

		await new Promise(resolve => {
			this.setState({
				selectedCountyTmp: null,
				selectedCountyCode: '0',
			}, resolve);
		});

		await this.getAvailableIndicators();

		// Step 4 自動全選四分類的所有指標，然後模擬按下「看評估結果」
		const { selectedAvailableIndicators } = this.state;
		const allSelectedValues = selectedAvailableIndicators.map(list =>
			(list || []).map(item => item.value)
		);
		await new Promise(resolve => {
			this.setState({ availableIndicatorsValue: allSelectedValues }, () => {
				this.handleValid();
				resolve();
			});
		});
		this.handleClickAdvanceSubmit();
	}
	updateSessionStorage = () => {
		// 如果已經有查詢結果，就更新 sessionStorage
		if (this.state.isDataLoaded) {
			const { selectedCountyTmp, selectedCountyCode, currentYearTmp, availableIndicatorsValue,
					csvData, originCsvData, resultData, availableIndicatorsData, availableIndicatorsValueItems,
					currentIndicatorName, currentIndicatorDescription, categoryToggle, currentIndicatorId,
					activePillCategoryIndex, activePillId } = this.state;

			sessionStorage.setItem('svi_z_query_state', JSON.stringify({
				selectedCountyTmp,
				selectedCountyCode,
				currentYearTmp,
				availableIndicatorsValue,
				csvData,
				originCsvData,
				resultData,
				availableIndicatorsData,
				availableIndicatorsValueItems,
				isDataLoaded: true,
				currentIndicatorName,
				currentIndicatorDescription,
				categoryToggle,
				currentIndicatorId,
				activePillCategoryIndex,
				activePillId
			}));
		}
	}
	getQuery() {
		const report = queryString.parse(window.location.search);
		if (report.county && report.indicator && report.year) {
			const year = report.year;
			const indicatorId = report.indicator;
			const county = report.county;
			this.setState({ isChartShow: true, isAdvanceLoading: true, isAdvance: true });
			this.getAvailableYears().then(() => {
				this.handleChangeYear(year).then(() => {
					this.handleCountyDistrictPickSelected(county).then(() => {
						this.getAvailableIndicators().then(() => {
							this.handleChangeIndicator(indicatorId).then(() => {
								this.handleGetAdvanceData(year, indicatorId);
							})
						})
					})
				});
			});
		}
		else if (report.county && report.year) {
			const year = report.year;
			const county = report.county;
			this.setState({ isChartShow: true, isBasicLoading: true });
			this.getAvailableYears().then(() => {
				this.handleChangeYear(year).then(() => {
					this.handleCountyDistrictPickSelected(county).then(() => {
						this.handleGetBasicData();
					})
				});
			});
		}
	}
	getCategoryDescription() {
		Axios.get(`${apiHost}/api/WeakIndex/GetCategoriesDetail`)
			.then(res => {
				res.status === 200 && this.setState({ categoryDescription: res.data.Result })
			})
	}
	getAllIndicators() {
		Axios.get(`${apiHost}/api/WeakIndex/GetCompleteIndicator`)
			.then((res) => {
				if (res.status === 200) {
					const { categories, subcategories, indicators } = res.data.Result
					categories.forEach((item) => {
						item.name = item.category_name;
					});
					subcategories.forEach((item) => {
						item.name = item.subcategory_name;
					});
					const allIndicators = [].concat(categories, subcategories, indicators)
					this.setState({ allIndicators })
				}
			})
	}
	getAvailableIndicators() {
		// const { currentYear, selectedCounty,  isBasicLoading} = this.state;
		const { currentYearTmp, selectedCountyTmp } = this.state;
		let countyCode = selectedCountyTmp ? selectedCountyTmp.code : 'all';
		// let county = selectedCountyTmp ? selectedCountyTmp.county : '';
		this.setState({ isAdvanceLoading: true })

		return new Promise(resolve => {
			Axios.get(`${apiHost}/api/WeakIndex/ZIndicatorsByYear?year=${currentYearTmp}&county=${countyCode}`)
				.then((res) => {
					if (res.status === 200) {
						const indicatorsData = res.data.Result.indicators;
						const categoriesData = res.data.Result.categories;
						const availableIndicators = [];
						categoriesData.forEach((category) => {
							category.indicators = [];
							indicatorsData.forEach((indicator) => {
								if (category.category_id === indicator.category_id) {
									category.indicators.push(indicator);
								}
							})
							availableIndicators.push(category);
						});
						// 指標選單data	
						let selectedAvailableIndicators = [[], [], [], []];
						// let availableIndicatorsValue = [[], [], [], []];
						let availableIndicatorsValueTmp = [];
						availableIndicators.map((item) => {
							const category = item.category_id;
							if (category == 1) {
								selectedAvailableIndicators[0] = getIndicators(item)
								// availableIndicatorsValue[0] = getIndicatorsValue(item)
							} else if (category == 2) {
								selectedAvailableIndicators[1] = getIndicators(item)
								// availableIndicatorsValue[1] = getIndicatorsValue(item)
							} else if (category == 3) {
								selectedAvailableIndicators[2] = getIndicators(item)
								// availableIndicatorsValue[2] = getIndicatorsValue(item)
							} else if (category == 4) {
								selectedAvailableIndicators[3] = getIndicators(item)
								// availableIndicatorsValue[3] = getIndicatorsValue(item)
							}
						})
						// let availableIndicatorsValueItems = [...selectedAvailableIndicators]
						// 選單與值比對，無在選單的值要移除
						availableIndicatorsValueTmp = this.state.availableIndicatorsValue;
						availableIndicatorsValueTmp = filterValue(indicatorsData, this.state.availableIndicatorsValue);

						//選單與值比對，無在選單的值要移除
						function filterValue(indicatorsData, indicatorValue) {
							return indicatorValue.map(subArray => subArray.filter(value => indicatorsData.some(indicator => indicator.indicator_id === value)).map(value => value));
						}

						function getIndicators(item) {
							return item.indicators.map((indicator) => ({
								label: indicator.name,
								value: indicator.indicator_id,
								role: indicator.subcategory_name,
								category: indicator.category_id,
							}));
						}
						function getIndicatorsValue(item) {
							return item.indicators.map(indicator => indicator.indicator_id)
						}

						// 檢查是否有待恢復的狀態
						const shouldRestore = this.state.isRestoringFromSession && this.pendingRestoreState;

						// 判斷是否應該保留現有的用戶選擇
						const hasUserSelection = this.state.availableIndicatorsValue &&
							this.state.availableIndicatorsValue.some(arr => arr && arr.length > 0);
						const shouldKeepUserSelection = !shouldRestore && (this.state.isDataLoaded || hasUserSelection);

						this.setState({
							isAdvanceLoading: false,
							availableIndicators,
							selectedAvailableIndicators,
							availableIndicatorsValue: shouldRestore ? this.pendingRestoreState.availableIndicatorsValue : availableIndicatorsValueTmp,
							// 恢復查詢結果
							csvData: shouldRestore ? this.pendingRestoreState.csvData : this.state.csvData,
							originCsvData: shouldRestore ? this.pendingRestoreState.originCsvData : this.state.originCsvData,
							resultData: shouldRestore ? this.pendingRestoreState.resultData : this.state.resultData,
							availableIndicatorsData: shouldRestore ? this.pendingRestoreState.availableIndicatorsData : this.state.availableIndicatorsData,
							availableIndicatorsValueItems: shouldRestore ? this.pendingRestoreState.availableIndicatorsValueItems : this.state.availableIndicatorsValueItems,
							isDataLoaded: shouldRestore ? this.pendingRestoreState.isDataLoaded : this.state.isDataLoaded,
							currentIndicatorName: shouldRestore ? this.pendingRestoreState.currentIndicatorName : this.state.currentIndicatorName,
							currentIndicatorDescription: shouldRestore ? this.pendingRestoreState.currentIndicatorDescription : this.state.currentIndicatorDescription,
							categoryToggle: shouldRestore ? this.pendingRestoreState.categoryToggle : (shouldKeepUserSelection ? this.state.categoryToggle : [false, false, false, false]),
							currentIndicatorId: shouldRestore ? this.pendingRestoreState.currentIndicatorId : this.state.currentIndicatorId,
							activePillCategoryIndex: shouldRestore ? this.pendingRestoreState.activePillCategoryIndex : this.state.activePillCategoryIndex,
							activePillId: shouldRestore ? this.pendingRestoreState.activePillId : this.state.activePillId,
							isRestoringFromSession: false,
						}, () => {
							// 清除待恢復狀態
							if (shouldRestore) {
								this.pendingRestoreState = null;
								this.updateSessionStorage();
							}
							this.handleValid();
							resolve();
						})
					}
				})
		})
	}
	// 測試區
	handleTableCollapseToggle = () => {

		this.setState({
			tableCollapseToggle: !this.state.tableCollapseToggle
		}, () => {
		})
	}

	// 點 tab 整塊（同時連動勾選狀態）：
	//   pos === -1 → 綜合結果
	handleTabClick = (pos, id) => {
		if (pos === -1) {
			this.setState({ activePillCategoryIndex: null, activePillId: null });
			this.handleClickAdvanceLink(-1, 0);
		} else if (this.state.categoryToggle[pos]) {
			this.setState({ activePillCategoryIndex: pos, activePillId: null });
			this.handleChangeCategoryToggle(false, pos, id);
		} else {
			this.setState({ activePillCategoryIndex: pos, activePillId: null });
			this.handleChangeCategoryToggle(true, pos, id);
		}
	}
	// 點 tab 內的 checkbox：切換該分類整體 toggle，同時把該分類的 pill 列展開
	handleTabCheckboxClick = (pos, id) => {
		if (this.state.categoryToggle[pos]) {
			this.setState({ activePillId: null });
			this.handleChangeCategoryToggle(false, pos, id);
		} else {
			this.setState({ activePillCategoryIndex: pos, activePillId: null });
			this.handleChangeCategoryToggle(true, pos, id);
		}
	}
	// 點 tab 內的文字 label：只展開該分類 pill 列，不切換 toggle
	handleTabLabelClick = (pos) => {
		this.setState({ activePillCategoryIndex: pos });
	}
	handleCollapseToggle = (pos) => {

		let state = { ...this.state.isShowCollapse };
		state[pos] = !this.state.isShowCollapse[pos];
		if (pos == 0) {
			if (this.state.isShowCollapse[0]) {
				state = [false, false, false, false, false];
			} else {
				state = [true, true, true, true, true];
			}
		}

		this.setState({
			isShowCollapse: state
		})
	}
	// 指標選單Change
	handleSelectedAvailableIndicatorsChange = (value, position) => {
		const { selectedAvailableIndicators, availableIndicatorsValue, availableIndicatorsValueItems } = this.state;
		// 被選的值
		availableIndicatorsValue[position] = value;
		// 值的item內容
		// availableIndicatorsValueItems[position]=availableIndicatorsValue[position].map(id=>{
		// 	return selectedAvailableIndicators[position].find(item=>id==item.value)
		// });
		this.setState({
			availableIndicatorsValue,
			// availableIndicatorsValueItems
		}, () => {
			this.handleValid();
		})
	}
	// 單一指標Clcik
	handleClickAdvanceLink = (pos, indicator) => {

		// function findNumberPosition(array, number) {
		// 	const index = array.findIndex(subArray => subArray.indexOf(number) !== -1);
		// 	return index !== -1 ? array[index].indexOf(number) + 1 : -1;
		// }
		let markerState = [false, false, false, false]
		// console.log('pos', pos);
		if (pos != -1) {
			markerState[pos] = true;
		}
		this.setState({
			currentIndicatorId: indicator,
			categoryToggle: [false, false, false, false],
			markerToggle: markerState
		}, () => {
			// this.handleGetAdvanceData();
			this.handleGetZvalueSingle();
			// this.handleGetZvalueComplex();
		});
	}
	// 指標選項全選
	handleSelectedAvailableIndicatorsAll = (position) => {
		const { selectedAvailableIndicators, availableIndicatorsValue, availableIndicatorsValueItems } = this.state;
		availableIndicatorsValue[position] = selectedAvailableIndicators[position].map(item => item.value);
		// availableIndicatorsValueItems[position]=selectedAvailableIndicators[position];
		this.setState({
			availableIndicatorsValue,
			// availableIndicatorsValueItems
		}, () => {
			this.handleValid();
		});
	}
	// Switch toggle
	handleChangeCategoryToggle = (checked, position, indicator_id) => {
		let toggle = [false, false, false, false];
		toggle[position] = checked;
		this.setState({
			categoryToggle: toggle,
			currentIndicatorId: indicator_id,
			markerToggle: [false, false, false, false]
		}, () => {
			// if(checked)	this.handleGetAdvanceData();
			if (checked) this.handleGetZvalueSingle();
			// if(checked)	this.handleGetZvalueComplex();
		})
	}
	// 單筆indicator
	handleGetZvalueSingleXXX = () => {
		const { currentYear, currentIndicatorId, selectedCounty, availableIndicatorsData } = this.state;
		const indicator = availableIndicatorsData.find(item => item.indicator_id == currentIndicatorId);
		let county = selectedCounty ? selectedCounty.county : '';
		let csvData = typeof indicator.csv === 'object' ? [indicator.csv] : indicator.csv;
		let desIndicator = this.state.allIndicators.find(item => item.indicator_id == indicator.indicator_id)

		this.setState({
			csvData: csvData,
			resultData: {
				year: currentYear,
				county: county,
				town: '',
				data: indicator.data,
			},
			currentIndicatorName: indicator.title ? indicator.title : '',
			currentIndicatorDescription: desIndicator && desIndicator.descriptionDes,
		}, () => {
			// console.log('resultData', this.state.resultData)
		})
	}
	handleGetZvalueSingle = () => {
		const { currentYear, currentIndicatorId, selectedCounty, availableIndicatorsData } = this.state;
		let desIndicator = this.state.allIndicators.find(item => item.indicator_id == currentIndicatorId)
		// console.log('this.state.allIndicators', this.state.allIndicators);
		// console.log('availableIndicatorsData', availableIndicatorsData);
		// console.log('availableIndicatorsData.indicator_id', availableIndicatorsData.indicator_id);
		// console.log('desIndicator', desIndicator);
		this.setState({
			currentIndicatorName: availableIndicatorsData.title ? availableIndicatorsData.title : '',
			currentIndicatorDescription: desIndicator && desIndicator.descriptionDes,
		}, () => {
			// console.log('resultData', this.state.resultData)
			// console.log(this.state.currentIndicatorDescription);
			this.handleGetZvalueComplex();
		})
	}
	// 多筆indicators
	handleGetZvalueComplexXXX = () => {
		const { currentYearTmp, currentIndicatorId, selectedCountyTmp, availableIndicatorsValue, selectedAvailableIndicators } = this.state;
		let countyCode = selectedCountyTmp ? selectedCountyTmp.code : 'all';
		let county = selectedCountyTmp ? selectedCountyTmp.county : '';
		this.setState({
			isAdvanceLoading: true,
			// isDataLoaded: false,
			isING: true,
		});

		// categoryToggle狀態
		const categoryIndicatorId = [1, 2, 3, 4];
		// const position = categoryIndicatorId.indexOf(Number(currentIndicatorId));
		// let categoryToggle = [false, false, false, false];
		// categoryToggle[position] = true;
		// this.setState({categoryToggle},()=>{})

		let indicators = availableIndicatorsValue.flat();
		let data = {
			year: currentYearTmp,
			indicators: [0, ...categoryIndicatorId, ...indicators],
			countyCode
		}
		let availableIndicatorsValueItems = [[], [], [], []];
		availableIndicatorsValue.map((value, index) => {
			// 值的item內容
			availableIndicatorsValueItems[index] = availableIndicatorsValue[index].map(id => {
				return selectedAvailableIndicators[index].find(item => id == item.value)
			}).filter(Boolean);
		})
		Axios.post(`${apiHost}/api/WeakIndex/ZValueComplex`, data)
			.then((res) => {
				// console.log('跳出');
				if (res.status === 200) {
					// console.log('true');
					const { allIndicators, availableIndicators } = this.state;
					const currentIndicator = allIndicators.filter((item) => {
						return item.indicator_id === Number(currentIndicatorId);
					})
					let indicatorArray = [];
					availableIndicators.map(item => {
						item.indicators.map(indicator => {
							indicatorArray.push(indicator)
						})
					})
					const indicator = indicatorArray.find((item) => {
						return item.indicator_id === Number(currentIndicatorId);
					})
					let position = 0;
					res.data.Result.data.find((item, index) => {
						if (item.indicator_id == Number(currentIndicatorId)) {
							position = index
						}
					});
					// console.log('res.data.Result', res.data.Result)
					// let csvData = typeof res.data.Result.csv === 'object' ? [res.data.Result.csv] : res.data.Result.csv;
					let csvData = typeof res.data.Result.data[position].csv === 'object' ? [res.data.Result.data[position].csv] : res.data.Result.data[position].csv;
					this.setState({
						isAdvanceLoading: false,
						isDataLoaded: true,
						currentIndicatorName: '',
						// currentIndicatorDescription: currentIndicator[0] ? currentIndicator[0].description : '',
						currentIndicatorDescription: indicator ? indicator.indicatordes : '',
						csvData: csvData,
						resultData: {
							year: currentYearTmp,
							county: county,
							town: '',
							data: res.data.Result.data[position].data,
						},
						availableIndicatorsData: res.data.Result.data,
						availableIndicatorsValueItems,
						categoryToggle: [false, false, false, false],
						currentYear: currentYearTmp,
						selectedCounty: selectedCountyTmp,
						isING: false

					}, () => {
						// urlPushState(`?year=${currentYear}&county=${countyCode}&indicator=${currentIndicatorId}`);
						// console.log('resultData', this.state.resultData)
					})
				}
			})
	}
	handleGetZvalueComplex = () => {
		const { currentYearTmp, currentIndicatorId, selectedCountyTmp, availableIndicatorsValue, selectedAvailableIndicators } = this.state;
		let countyCode = selectedCountyTmp ? selectedCountyTmp.code : 'all';
		let county = selectedCountyTmp ? selectedCountyTmp.county : '';
		this.setState({
			// isAdvanceLoading: true,
			isING: true,
		});

		// categoryToggle狀態
		const categoryIndicatorId = [1, 2, 3, 4];
		let indicators;
		if (currentIndicatorId == 0) {
			indicators = [0, ...categoryIndicatorId, ...availableIndicatorsValue.flat()];
		} else if (currentIndicatorId == 1 || currentIndicatorId == 2 || currentIndicatorId == 3 || currentIndicatorId == 4) {

			indicators = [currentIndicatorId, ...availableIndicatorsValue[currentIndicatorId - 1]];
		} else {
			indicators = [currentIndicatorId];
		}
		let data = {
			year: currentYearTmp,
			indicators,
			countyCode
		}
		let availableIndicatorsValueItems = [[], [], [], []];
		availableIndicatorsValue.map((value, index) => {
			// 值的item內容
			availableIndicatorsValueItems[index] = availableIndicatorsValue[index].map(id => {
				return selectedAvailableIndicators[index].find(item => id == item.value)
			}).filter(Boolean);
		})
		Axios.post(`${apiHost}/api/WeakIndex/ZValueComplex`, data)
			.then((res) => {
				if (res.status === 200) {
					const { allIndicators, availableIndicators } = this.state;
					const currentIndicator = allIndicators.filter((item) => {
						return item.indicator_id === Number(currentIndicatorId);
					})
					let indicatorArray = [];
					availableIndicators.map(item => {
						item.indicators.map(indicator => {
							indicatorArray.push(indicator)
						})
					})
					// console.log(res.data.Result);
					// console.log('currentIndicator', currentIndicator);
					let csvData = typeof res.data.Result.data[0].csv === 'object' ? [res.data.Result.data[0].csv] : res.data.Result.data[0].csv;
					let originCsvData = typeof res.data.Result.data[0].csvOrigin === 'object' ? [res.data.Result.data[0].csvOrigin] : res.data.Result.data[0].csvOrigin;
					this.setState({
						isAdvanceLoading: false,
						isDataLoaded: true,
						currentIndicatorName: currentIndicator[0] ? currentIndicator[0].name : '',
						currentIndicatorDescription: currentIndicator[0] ? currentIndicator[0].descriptionDes : '',
						csvData: csvData,
						originCsvData: originCsvData,
						resultData: {
							year: currentYearTmp,
							county: county,
							town: '',
							data: res.data.Result.data[0].data,
						},
						availableIndicatorsData: res.data.Result.data[0],
						availableIndicatorsValueItems,
						currentYear: currentYearTmp,
						selectedCounty: selectedCountyTmp,
						isING: false,

					}, () => {
						// 儲存查詢結果到 sessionStorage
						this.updateSessionStorage();
						// urlPushState(`?year=${currentYear}&county=${countyCode}&indicator=${currentIndicatorId}`);
						// console.log('resultData', this.state.resultData)
						// console.log('currentIndicatorDescription',this.state.currentIndicatorDescription);
					})
				}
			})
	}
	// 驗證
	handleValid = () => {
		const { isAdvanceLoading, availableIndicatorsValue, selectedCountyCode, currentYearTmp } = this.state;
		const hasData = availableIndicatorsValue.every(item => item.length > 0);
		const hasSelectedYear = currentYearTmp !== '0';
		const hasSelectedCounty = selectedCountyCode !== '';
		
		if (isAdvanceLoading == false && hasData && hasSelectedYear && hasSelectedCounty) {
			this.setState({ isValid: true })
		} else {
			this.setState({ isValid: false })
		}
	}
	// Collapse 
	handleCollapseClick = (e) => {
		e.target.classList.add("isOpen");
	}
	// 測試 END
	getAvailableYears() {
		return new Promise(resolve => {
			Axios.get(`${apiHost}/api/WeakIndex/InitialZYear`)
				.then((res) => {
					if (res.status === 200) {
						const result = res.data.Result;
						result.sort(function (a, b) { return b - a });
						this.setState({
							availableYears: result
						})
						resolve();
					}
				})
		})
	}
	getCountiesData = (year) => {
		return new Promise((resolve) => {
			if (!year) {
				resolve();
				return;
			}
			Axios.get(`${apiHost}/api/WeakIndex/InitialZCounty?year=${year}`)
				.then((res) => {
					if (res.status === 200) {
						const countiesData = res.data.Result.counties;
						console.log(countiesData);
						this.setState({
							countiesData: countiesData
						}, () => {
							resolve();
						})
					}
				})
		});


		// Axios.get('/config/CountiesTownsData.json')
		// 	.then(result => {
		// 		const { counties } = result.data;
		// 		counties.forEach(county => county.active = false);
		// 		this.setState({ countiesData: counties });
		// 	})
	}
	handleClickBasicSubmit = () => {
		this.setState({ isChartShow: true, });
		this.handleGetBasicData();
	}
	handleGetBasicData() {
		const { currentYear, selectedCounty } = this.state;
		let countyCode = selectedCounty ? selectedCounty.code : 'all';
		let county = selectedCounty ? selectedCounty.county : '';
		this.setState({ isBasicLoading: true });
		Axios.get(`${apiHost}/api/WeakIndex/ZValueComplete?year=${currentYear}&county=${countyCode}`)
			.then((res) => {
				if (res.status === 200 && res.data) {
					this.getAvailableIndicators();
					const csvData = (typeof res.data.Result.csv === 'object' && res.data.Result.csv !== null) ? [res.data.Result.csv] : res.data.Result.csv;
					const originCsvData = (typeof res.data.Result.csvOrigin === 'object' && res.data.Result.csvOrigin !== null) ? [res.data.Result.csvOrigin] : res.data.Result.csvOrigin;
					this.setState({
						isBasicLoading: false,
						isDataLoaded: true,
						isAdvance: true,
						currentIndicatorName: '',
						currentIndicatorDescription: '',
						currentIndicatorId: '',
						csvData: csvData,
						originCsvData: originCsvData,
						resultCounty: selectedCounty,
						resultData: {
							year: currentYear,
							county: county,
							town: '',
							data: res.data.Result.data,
						}
					}, () => urlPushState(`?year=${currentYear}&county=${countyCode}`));
				}
			})
	}
	handleClickAdvanceSubmit = () => {
		// id 本來就是 '0' 時 componentDidUpdate 不會觸發 loadCaseStories，需顯式補呼叫
		// 確保綜合情境下重新勾選 Step 4 後案例故事排序會更新
		const wasZero = this.state.currentIndicatorId === '0';
		this.setState({
			currentIndicatorId: '0',
			hasClickedAdvanceSubmit: true, //按下評估結果才會顯示傳到情資網的按鍵功能
			categoryToggle: [false, false, false, false],  // 重置 Toggle 開關狀態
			markerToggle: [false, false, false, false],    // 重置標記狀態
			activePillCategoryIndex: null,                 // 重置 tab 展開狀態
			activePillId: null,                            // 重置 pill 選取狀態
			isING: true,                                   // 立刻顯示右側 loading
		}, () => {
			// 在狀態更新完成後才調用查詢函數
			this.handleGetZvalueComplex();
			if (wasZero) this.loadCaseStories();
		});
	}
	
	handleGetAdvanceData() {
		const { currentYear, currentIndicatorId, selectedCounty } = this.state;
		let countyCode = selectedCounty ? selectedCounty.code : 'all';
		let county = selectedCounty ? selectedCounty.county : '';
		this.setState({ isAdvanceLoading: true });

		// categoryToggle狀態
		const categoryIndicatorId = [1, 2, 3, 4];
		const position = categoryIndicatorId.indexOf(Number(currentIndicatorId));
		let categoryToggle = [false, false, false, false];
		categoryToggle[position] = true;
		this.setState({ categoryToggle }, () => {
		})


		// console.log(`${apiHost}/api/WeakIndex/ZValueSingle?year=${currentYear}&indicators=${currentIndicatorId}&county=${countyCode}`)
		Axios.get(`${apiHost}/api/WeakIndex/ZValueSingle?year=${currentYear}&indicators=${currentIndicatorId}&county=${countyCode}`)
			.then((res) => {
				if (res.status === 200) {
					const { allIndicators, availableIndicators } = this.state;
					const currentIndicator = allIndicators.filter((item) => {
						return item.indicator_id === Number(currentIndicatorId);
					})
					let indicatorArray = [];
					availableIndicators.map(item => {
						item.indicators.map(indicator => {
							indicatorArray.push(indicator)
						})
					})
					const indicator = indicatorArray.find((item) => {
						return item.indicator_id === Number(currentIndicatorId);
					})
					let csvData = typeof res.data.Result.csv === 'object' ? [res.data.Result.csv] : res.data.Result.csv;
					let originCsvData = (typeof res.data.Result.csvOrigin === 'object' && res.data.Result.csvOrigin !== null) ? [res.data.Result.csvOrigin] : res.data.Result.csvOrigin;
					this.setState({
						isAdvanceLoading: false,
						isDataLoaded: true,
						currentIndicatorName: currentIndicator[0] ? currentIndicator[0].name : '',
						// currentIndicatorDescription: currentIndicator[0] ? currentIndicator[0].description : '',
						currentIndicatorDescription: indicator ? indicator.indicatordes : '',
						csvData: csvData,
						originCsvData: originCsvData,
						resultData: {
							year: currentYear,
							county: county,
							town: '',
							data: res.data.Result.data,
						},
					}, () => urlPushState(`?year=${currentYear}&county=${countyCode}&indicator=${currentIndicatorId}`))
				}
			})
	}
	handleClickDownloadCSV = () => {
		const { csvData, originCsvData, resultCounty, currentYear, currentIndicatorName, allIndicators } = this.state;
		let csv = '';
		// 優先用 originCsvData (未四捨五入)，沒有才 fallback 到 csvData
		const downloadSource = (originCsvData && originCsvData.length > 0) ? originCsvData : (csvData || []);
		downloadSource.forEach((item) => {
			csv = csv + '\n' + item.csv;
		});



		const fileName = `${currentYear}年 ${resultCounty ? resultCounty.county : '全臺各縣市'}${currentIndicatorName}原始資料`;

		let allSource = {};
		allIndicators.forEach(indicator => {
			if (indicator.source) {
				allSource[indicator.name] = indicator.source[0];
			} else {
				allSource[indicator.name] = '';
			}
		})
		let source = '';
		if (allSource[currentIndicatorName]) {
			source = allSource[currentIndicatorName];
		}
		let copyright = '\n資料來源：減災動資料(加值前的原始數據來源為';
		if (source.length === 0) {
			copyright = '\n資料來源：國家災害防救科技中心減災動資料 ( 加值前的原始數據來源詳見社會脆弱度評估系統首頁「指標細項定義」)。';
		} else {
			copyright += source;
		}
		copyright += ')';

		const csvContent = "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csv) + copyright;

		downloadTrigger(fileName + '.csv', csvContent);
		gaTracking('社會脆弱度', '社會脆弱度指標查詢與展示', '原始數據下載');

	}
	handleChangeYear(year) {
		return new Promise(resolve => {
			this.setState({
				currentYearTmp: year,
				selectedCountyTmp: null,  // 重置選擇的行政區
				selectedCountyCode: '',   // 重置選擇的行政區代碼
				isValid: false  // 重置驗證狀態
			}, () => {
				this.getCountiesData(year);
				// 移除自動調用 getAvailableIndicators()
				resolve()
			});
		})
	}
	handleCountyDistrictPickSelected = selectedCode => {
		return new Promise(resolve => {
			const { countiesData } = this.state;
			if (!selectedCode || selectedCode === '') {
				// 如果沒有選擇行政區，清空相關狀態（不清 availableIndicators 讓 Step4 保留）
				this.setState({
					selectedCountyTmp: null,
					selectedCountyCode: '',
					isValid: false
				}, () => {
					resolve();
				});
				return;
			}

			let selectedDistrict = null;
			if (selectedCode === '0') {
				// 全選的情況，設定為null（代表全選）
				selectedDistrict = null;
			} else {
				// 選擇特定行政區
				selectedDistrict = countiesData.find(({ code }) => code === selectedCode);
			}

			// 清除 sessionStorage 快取
			sessionStorage.removeItem('svi_z_query_state');

			// 不把 availableIndicators 設 null，避免 Step4 閃掉；新資料回來會直接覆蓋
			this.setState({
				selectedCountyTmp: selectedDistrict,
				selectedCountyCode: selectedCode,
			}, () => {
				// 只有在選擇了行政區後才調用 getAvailableIndicators
				this.getAvailableIndicators();
				resolve();
			});
		})
	}
	handleChangeIndicator(indicator) {
		return new Promise(resolve => {
			this.setState({ currentIndicatorId: indicator }, () => resolve());
		})
	}
	handleClickDownloadPNG = (e) => {
		e.preventDefault();
		const { currentYearTmp, currentIndicatorName, selectedCountyTmp, resultData } = this.state;
		const countyName = selectedCountyTmp ? selectedCountyTmp.county : '';
		const fileName = `${currentYearTmp}年 ${countyName || '全臺各縣市'}${currentIndicatorName}圖表`;

		// 有設計師排版 SVG 的縣市，使用 SVG 地圖下載（不含數值）
		// 只有在停留在該縣市的鄉鎮層 view（沒下鑽到村里）才走設計版 SVG；
		// 有選鄉鎮時走 chartCapture 截可見畫面，避免用 town-level SVG 塗 village 資料。
		const mapKey = countyName || '全臺';
		if (hasSvgMap(mapKey) && resultData && resultData.data && !resultData.town) {
			const titleText = `${currentYearTmp}年 ${countyName || '全臺各縣市'} ${currentIndicatorName}`;
			svgMapCapture(mapKey, resultData.data, fileName, titleText, false);
		} else {
			// 沒有設計師 SVG 的縣市，維持原本的截圖方式
			const mapNamesMain = document.querySelectorAll('.captureText-hidden .map-names');
			const mapNamesIsland = document.querySelectorAll('.captureText-hidden .map-name');
			mapNamesMain.forEach(el => { el.style.display = 'none'; });
			mapNamesIsland.forEach(el => { el.style.display = 'none'; });

			// 說明文字直接用 captureText-hidden 內的那份：它不限高、不捲動，
			// 又和地圖同屬一個截圖元素，不會有跨元素的裁切偏移。
			const captureArea = document.querySelectorAll('.heading.captureText, .captureText-hidden');
			chartCapture(captureArea, fileName, undefined, () => {
				mapNamesMain.forEach(el => { el.style.display = ''; });
				mapNamesIsland.forEach(el => { el.style.display = ''; });
			});
		}

		gaTracking('社會脆弱度', '社會脆弱度指標查詢與展示', '圖表下載');
	}
	handleClickDownloadTextPNG = () => {
		const { currentYear, currentIndicatorId, selectedCounty } = this.state;
		let countyCode
		if (!selectedCounty || selectedCounty === null) {
			countyCode = 'all'
		} else {
			countyCode = selectedCounty.code
		}
		if (currentIndicatorId === '0') {
			window.open(`${loginApiHost}/map/?year=${currentYear}&county=${countyCode}`)
		} else {
			window.open(`${loginApiHost}/map/?year=${currentYear}&county=${countyCode}&indicator=${currentIndicatorId}`)
		}
	}
	handleClickDownloadTextPNG = (e) => {
		e.preventDefault();
		const { currentYearTmp, currentIndicatorName, selectedCountyTmp, resultData } = this.state;
		const countyName = selectedCountyTmp ? selectedCountyTmp.county : '';
		const fileName = `${currentYearTmp}年 ${countyName || '全臺各縣市'}${currentIndicatorName}圖表`;

		// 有設計師排版 SVG 的縣市，使用 SVG 地圖下載（含拉線標註）
		// 只有在停留在該縣市的鄉鎮層 view（沒下鑽到村里）才走設計版 SVG；
		// 有選鄉鎮時走 chartCapture 截可見畫面，避免用 town-level SVG 塗 village 資料。
		const mapKey = countyName || '全臺';
		if (hasSvgMap(mapKey) && resultData && resultData.data && !resultData.town) {
			const titleText = `${currentYearTmp}年 ${countyName || '全臺各縣市'} ${currentIndicatorName}`;
			svgMapCapture(mapKey, resultData.data, fileName, titleText);
		} else {
			// 其他縣市維持原本的截圖方式
			// 說明文字直接用 captureText-hidden 內的那份：它不限高、不捲動，
			// 又和地圖同屬一個截圖元素，不會有跨元素的裁切偏移。
			const captureArea = document.querySelectorAll('.heading.captureText, .captureText-hidden');
			chartCapture(captureArea, fileName, undefined);
		}

		gaTracking('社會脆弱度', '社會脆弱度指標查詢與展示', '圖表下載');
	}
	initLayout = () => {
		const params = new URLSearchParams(this.props.location.search);
        const ref = params.get('ref');
		const showOpt = ref === "eocdss";
        this.setState({ showOpt }, () => {
            this.props.SetShowOpt(!showOpt);
        });
	}
	postMessage = () => {
		// if (window.parent !== window) {
		// 	console.log(window.parent);
		// 	let message = "test Message";
		// 	// let targetdomain = "https://ansel.gis.fcu.edu.tw"//之後改為正式網址
		// 	// window.parent.postMessage(message, targetdomain);

		// 	let targetDomains = [
		// 		"https://eocdss.ncdr.nat.gov.tw/",
		// 		"https://ceocdss.ncdr.nat.gov.tw/",
		// 		"https://dssdrill.ncdr.nat.gov.tw/",
		// 		"https://ncdr3d.richitech.com.tw/"
		// 	];
	
		// 	targetDomains.forEach(domain => {
		// 		window.parent.postMessage(message, domain);
		// 	});


		// 	alert("訊息已傳送：" + message);
		// } else {
		// 	alert("此頁未嵌入 iframe，無法傳送訊息。");
		// }

	const { currentYearTmp, currentIndicatorId, selectedCountyTmp, availableIndicatorsValue } = this.state;
    let countyCode = selectedCountyTmp ? selectedCountyTmp.code : 'all';
    let indicators;

    const categoryIndicatorId = [1, 2, 3, 4];

    if (currentIndicatorId == 0) {
        indicators = [0, ...categoryIndicatorId, ...availableIndicatorsValue.flat()];
    } else if (currentIndicatorId == 1 || currentIndicatorId == 2 || currentIndicatorId == 3 || currentIndicatorId == 4) {
        indicators = [currentIndicatorId, ...availableIndicatorsValue[currentIndicatorId - 1]];
    } else {
        indicators = [currentIndicatorId];
    }

    let data = {
        year: currentYearTmp,
        indicators,
        countyCode
    };

	Axios.post(`${apiHost}/api/WeakIndex/ZValueForEocdss`, data)
        .then((res) => {
            if (res.status === 200) {
                // console.log("API 回應:", res.data);
                // alert("API 回應成功：" + JSON.stringify(res.data));
				// 將 JSON 格式化並顯示在 textarea
				// let formattedJson = JSON.stringify(res.data, null, 4);
				// document.querySelector(".captureText-hidden").value = formattedJson; 

                if (window.parent !== window) {
                    let message = JSON.stringify(res.data);
                    let targetDomains = [
                        "https://eocdss.ncdr.nat.gov.tw/",
                        "https://ceocdss.ncdr.nat.gov.tw/",
                        "https://dssdrill.ncdr.nat.gov.tw/",
                        "https://ncdr3d.richitech.com.tw/"
                    ];
    
                    targetDomains.forEach(domain => {
                        window.parent.postMessage(message, domain);
                    });
                } else {
                    alert("此頁未嵌入 iframe，無法傳送訊息。");
                }
            }
        })
        .catch((error) => {
            console.error("API 請求錯誤:", error);
            alert("API 請求發生錯誤！");
        });
	}



	render() {
		// 取得目前網址的參數，來決定"單一年度行政區比較的連結"是否要加上ref=eocdss，防止跳轉回無ref=eocdss的頁面
		const params = new URLSearchParams(this.props.location.search);
    	const ref = params.get('ref');

		const { isMemberLogin } = this.state;
		const { availableYears, availableIndicators, categoryDescription } = this.state;
		const { currentYear, currentIndicatorId, currentIndicatorName, currentIndicatorDescription } = this.state;
		const { selectedCounty, resultCounty } = this.state;
		const { type, countiesData, csvData, resultData } = this.state;
		const { isDataLoaded, isBasicLoading, isAdvance, isAdvanceLoading, isING } = this.state;
		const { allIndicators } = this.state
		const currentIndicator = allIndicators.find(data => data.name === currentIndicatorName)

		// 測試
		const { selectedAvailableIndicators, availableIndicatorsValue, isValid } = this.state;
		const { showOpt } = this.state;
		const categoryTabs = [
			{ id: 'exposure',   label: '暴露量',   categoryIndex: 0, collapseIndex: 1, aggregateIndicatorId: 1 },
			{ id: 'mitigation', label: '減災整備', categoryIndex: 1, collapseIndex: 2, aggregateIndicatorId: 2 },
			{ id: 'response',   label: '應變能力', categoryIndex: 2, collapseIndex: 3, aggregateIndicatorId: 3 },
			{ id: 'recovery',   label: '復原能力', categoryIndex: 3, collapseIndex: 4, aggregateIndicatorId: 4 },
		];
		// 換年 / 換縣市 / 看評估結果 進行中時，Step4 指標選單與全選按鈕鎖住不能動
		const isLocked = isAdvanceLoading || this.state.isING;
		return (
			<React.Fragment>
				<Helmet>
					<title>減災動資料 - 社會脆弱度評估</title>
				</Helmet>
				<LimitMask prevPage="/evaluation/svi" />
				<div className="svi-page">
					<div className="container">
						{!showOpt &&
							<div className="page-link">
								<Link className="item" to="/evaluation/svi/advance">
									<span>客製化社會脆弱度評估</span>
								</Link>
							</div>
						}
						{/* {showOpt 
								&&<textarea className="captureText-hidden" style={{width: "220px", height: "130px"}}></textarea>
						} */}
						<div className="svi-charttitle">
							<div className="title">社會脆弱度指標查詢與展示</div>
							<div className="subtitle">Social Vulnerability Index for Disasters</div>
						</div>
						{/* 按下"看評估結果"按鈕且待評估結果顯示才會出現該按紐 */}
						{/* {showOpt && isDataLoaded &&
							<input type="button" value="demo" onClick={this.postMessage}></input>
						} */}
						<div className="svi-chart row">
							<div className="col-md-3 chart-controller">
								<div className="type">
									<div className="step">
										<div className="title">
											<span className="en">Step 1 </span>
											<span>選擇想查看的資料主題</span></div>
										<div className="buttonbar">
											<Link to={ref === "eocdss" ? "/evaluation/svi/z?ref=eocdss" : "/evaluation/svi/z"} className="-active"
												onMouseEnter={() => this.setState({ type: 'z' })}
												onMouseOut={() => this.setState({ type: 'z' })}>單一年度行政區比較</Link>
											{!showOpt &&
											<Link to="/evaluation/svi/s"
												onMouseEnter={() => this.setState({ type: 's' })}
												onMouseOut={() => this.setState({ type: 'z' })}>單一行政區歷史趨勢</Link>
												}
										</div>
										<div className="info">
											{type === 'z' && <p>單一年度行政區比較：了解不同縣市某一年中社會脆弱度的差異</p>}
											{type === 's' && <p>單一行政區趨勢：可了解如臺北市 1998 到 2016 年間的社會脆弱度趨勢。</p>}
										</div>
									</div>
								</div>
								<div className="basic">
									<div className="step">
										<div className="title">
											<span className="en">Step 2 </span>
											<span>選擇年份</span></div>
										<div className="select">
											<CustomSelect status="normal" name="year" value={this.state.currentYearTmp}
												onChange={(value) => this.handleChangeYear(value)}>
												<option value={'0'}>年份</option>
												{
													availableYears &&
													availableYears.map((year, index) =>
														<option key={index} value={year}>{year}</option>
													)
												}
											</CustomSelect>
										</div>
									</div>
									{
										<div className="step">
											<div className="title">Step 3 選擇行政區</div>
											<div className="select">
												<CustomSelect status="normal" name="year"
													value={this.state.selectedCountyCode}
													onChange={value => this.handleCountyDistrictPickSelected(value)}>
													<option value="">請選擇</option>
													<option value="0">全選</option>
													{
														countiesData &&
														countiesData.map((item, index) =>
															<option key={index} value={item.code}>{item.county}</option>
														)
													}
												</CustomSelect>
											</div>
										</div>
									}
									{
										// isAdvance && 
										// selectedAvailableIndicators.flat().length>0 && 
										(availableIndicators) && !this.state.isRestoringFromSession &&
										<div className="step">
											<div className="title">Step 4 選擇想要評估的指標</div>
											<div className="info mb-1">
												<div className='category-title'><span className='text-danger'>*</span>
													暴露量
													({
														`${this.state.availableIndicatorsValue[0].length} / ${this.state.selectedAvailableIndicators[0].length}`
													})
												</div>
												{
													this.state.selectedAvailableIndicators[0].length > 0 &&
													<button className='link' disabled={isLocked} onClick={() => this.handleSelectedAvailableIndicatorsAll(0)}>全選</button>
												}
											</div>
											<div className="select">
												{
													!this.state.selectedAvailableIndicators[0].length > 0 && <div className='noData'>無資料</div> ||
													this.state.selectedAvailableIndicators[0] &&
													<TagPicker
														data={selectedAvailableIndicators[0]}
														value={availableIndicatorsValue[0]}
														onChange={(value) => this.handleSelectedAvailableIndicatorsChange(value, 0)}
														placeholder='請選擇'
														groupBy="role"
														block
														disabled={isLocked}
														renderMenuGroup={(label, item) => {
															return (
																<>
																	{label}
																</>
															);
														}}
														searchable={false}
													/>
												}
											</div>
											{
												this.state.selectedAvailableIndicators[0].length > 0 && !this.state.availableIndicatorsValue[0].length > 0 &&
												<div className='text-danger mb-10 mt-n2'>至少勾選一項</div>
											}

											<div className="info mb-1">
												<div className='category-title'><span className='text-danger'>*</span>
													減災整備
													({
														`${this.state.availableIndicatorsValue[1].length} / ${this.state.selectedAvailableIndicators[1].length}`
													})
												</div>
												{

													this.state.selectedAvailableIndicators[1].length > 0 &&
													<button className='link' disabled={isLocked} onClick={() => this.handleSelectedAvailableIndicatorsAll(1)}>全選</button>
												}
											</div>
											<div className="select">
												{

													!this.state.selectedAvailableIndicators[1].length > 0 && <div className='noData'>無資料</div> ||
													this.state.selectedAvailableIndicators[1] &&
													<TagPicker
														data={selectedAvailableIndicators[1]}
														value={availableIndicatorsValue[1]}
														onChange={(value) => this.handleSelectedAvailableIndicatorsChange(value, 1)}
														placeholder='請選擇'
														groupBy="role"
														block
														disabled={isLocked}
														// onChange={this.handleChange}
														renderMenuGroup={(label, item) => {
															return (
																<>
																	{label}
																	{/* <span className='text-danger fs-12'>至少勾選一項</span> */}
																</>
															);
														}}
														searchable={false}
													/>
												}
											</div>
											{
												this.state.selectedAvailableIndicators[1].length > 0 && !this.state.availableIndicatorsValue[1].length > 0 &&
												<div className='text-danger mb-10 mt-n2'>至少勾選一項</div>
											}
											<div className="info mb-1">
												<div className='category-title'><span className='text-danger'>*</span>
													應變能力
													({
														`${this.state.availableIndicatorsValue[2].length} / ${this.state.selectedAvailableIndicators[2].length}`
													})
												</div>
												{

													this.state.selectedAvailableIndicators[2].length > 0 &&
													<button className='link' disabled={isLocked} onClick={() => this.handleSelectedAvailableIndicatorsAll(2)}>全選</button>
												}
											</div>
											<div className="select">
												{

													!this.state.selectedAvailableIndicators[2].length > 0 && <div className='noData'>無資料</div> ||
													this.state.selectedAvailableIndicators[2] &&
													<TagPicker
														data={selectedAvailableIndicators[2]}
														value={availableIndicatorsValue[2]}
														onChange={(value) => this.handleSelectedAvailableIndicatorsChange(value, 2)}
														placeholder='請選擇'
														groupBy="role"
														block
														disabled={isLocked}
														renderMenuGroup={(label, item) => {
															return (
																<>
																	{label}
																	{/* <span className='text-danger fs-12'>至少勾選一項</span> */}
																</>
															);
														}}
														searchable={false}
													/>
												}
											</div>
											{
												this.state.selectedAvailableIndicators[2].length > 0 && !this.state.availableIndicatorsValue[2].length > 0 &&
												<div className='text-danger mb-10 mt-n2'>至少勾選一項</div>
											}
											<div className="info mb-1">
												<div className='category-title'><span className='text-danger'>*</span>
													復原能力
													({
														`${this.state.availableIndicatorsValue[3].length} / ${this.state.selectedAvailableIndicators[3].length}`
													})
												</div>
												{

													this.state.selectedAvailableIndicators[3].length > 0 &&
													<button className='link' disabled={isLocked} onClick={() => this.handleSelectedAvailableIndicatorsAll(3)}>全選</button>
												}
											</div>
											<div className="select">
												{

													!this.state.selectedAvailableIndicators[3].length > 0 && <div className='noData'>無資料</div> ||
													this.state.selectedAvailableIndicators[3] &&
													<TagPicker
														data={selectedAvailableIndicators[3]}
														value={availableIndicatorsValue[3]}
														onChange={(value) => this.handleSelectedAvailableIndicatorsChange(value, 3)}
														placeholder='請選擇'
														groupBy="role"
														block
														disabled={isLocked}
														renderMenuGroup={(label, item) => {
															return (
																<>
																	{label}
																	{/* <span className='text-danger fs-12'>至少勾選一項</span> */}
																</>
															);
														}}
														searchable={false}
													/>
												}
											</div>
											{
												this.state.selectedAvailableIndicators[3].length > 0 && !this.state.availableIndicatorsValue[3].length > 0 &&
												<div className='text-danger mb-10 mt-n2'>至少勾選一項</div>
											}
										</div>
									}
									<div className="isDataLoaded">
										<div className="submit">
											<button className="button"
												disabled={isAdvanceLoading || isValid == false || this.state.isING}
												onClick={this.handleClickAdvanceSubmit}>看評估結果</button>
										</div>
									</div>									
								</div>
							</div>
							{
								<div className="col-md-9 chart-result">

									{/* tab頁籤（label + checkbox 並排，下方可展開 pill 列） */}
									{isDataLoaded &&
									<div className="svi-tabs">
										<div className="svi-tab-list">
												<div className="svi-tab-item">
													<button
														type="button"
														className="svi-tab-label"
														onClick={() => this.handleTabClick(-1, 0)}
													>
														綜合結果
													</button>
													<CustomCheckbox
														id="svi-tab-comprehensive"
														className=""
														checked={this.state.currentIndicatorId == 0 && !this.state.categoryToggle.some(Boolean)}
														onChange={() => this.handleTabClick(-1, 0)}
													/>
												</div>
											{categoryTabs.map(({ id: tabId, label, categoryIndex, aggregateIndicatorId }) => (
												<div className="svi-tab-item" key={tabId}>
													<button
														type="button"
														className={`svi-tab-label ${this.state.activePillCategoryIndex === categoryIndex ? 'open' : ''}`}
														onClick={() => this.handleTabLabelClick(categoryIndex)}
														disabled={!(selectedAvailableIndicators[categoryIndex] && selectedAvailableIndicators[categoryIndex].length)}
													>
														{label}
													</button>
													<CustomCheckbox
														id={`svi-tab-${categoryIndex}`}
														className=""
														checked={this.state.categoryToggle[categoryIndex]}
														onChange={() => this.handleTabCheckboxClick(categoryIndex, aggregateIndicatorId)}
														disabled={!(selectedAvailableIndicators[categoryIndex] && selectedAvailableIndicators[categoryIndex].length)}
													/>
												</div>
											))}
										</div>

										{this.state.activePillCategoryIndex !== null &&
											selectedAvailableIndicators[this.state.activePillCategoryIndex] &&
												selectedAvailableIndicators[this.state.activePillCategoryIndex].length > 0 && (
											<div className="svi-tab-indicators">
												{selectedAvailableIndicators[this.state.activePillCategoryIndex]
													.filter(item => availableIndicatorsValue[this.state.activePillCategoryIndex].includes(item.value))
													.map((item) => (
													<button
														key={item.value}
														className={`indicator-pill ${(this.state.categoryToggle[this.state.activePillCategoryIndex] && this.state.activePillId === null) || this.state.activePillId == item.value ? 'active' : ''}`}
														onClick={() => { this.setState({ activePillId: item.value }); this.handleClickAdvanceLink(this.state.activePillCategoryIndex, item.value); }}
														type="button"
													>
														{item.label}
													</button>
												))}
											</div>
										)}
										<div className="svi-tab-hint">*選擇不同「四分類」或「指標項目」，可檢視相對應評估結果。</div>
									</div>
									}

									{/* 結果標題 */}
									{!this.state.isING && isDataLoaded &&
										<div className="result-title heading captureText">
											{resultData.year}年 {resultData.county ? resultData.county : '全臺各縣市'}{currentIndicatorName !== '' ? `${currentIndicatorName}比較` : '社會脆弱度比較'}
										</div>
									}

									{
										(this.state.isING || isAdvanceLoading) &&
										<div className="chart">
											<LoadingDots theme="blue" >
												<p>系統處理中....請稍待</p>
											</LoadingDots>
										</div>
									}
									{
										!this.state.isING && !isAdvanceLoading && isDataLoaded &&
										<>
											{!showOpt &&
												<div className="chart-download-bar" data-html2canvas-ignore>
													<CustomDropdown title="下載">
														<React.Fragment>
															<li><button onClick={this.handleClickDownloadPNG}>下載PNG</button></li>
															<li><button onClick={this.handleClickDownloadTextPNG}>下載PNG(含數值)</button></li>
														</React.Fragment>
												</CustomDropdown>
												</div>
											}
											{showOpt && this.state.hasClickedAdvanceSubmit && !this.state.isING &&
												<div className="chart-download-bar" data-html2canvas-ignore>
													<input
														type="button"
														value="回傳至韌性防災評估模組"
														style={{
															padding: "6px",
															border: "1px solid #68aaff",
															backgroundColor: "#FFF",
															color: "#68aaff",
															cursor: "pointer",
														}}
														onClick={this.postMessage}
													/>
												</div>
											}

											{
												<div className="chart">
													{
														this.state.isING &&
														<LoadingDots theme="blue">
															<p>系統處理中....請稍待</p>
														</LoadingDots>
													}
													{
														// isAdvance &&
														// isDataLoaded &&
														<SviChartMap
															isIndicator={currentIndicatorName !== ''}
															currentIndicatorName={currentIndicatorName}
															sviData={resultData}
															related={currentIndicator ? currentIndicator.related : 99}
															currentIndicatorId={this.state.currentIndicatorId}
															categoryDescription={categoryDescription}
															currentIndicatorDescription={currentIndicatorDescription}
														/>
													}
												</div>
											}
											<div className="info capture captureText">
												{
													this.state.currentIndicatorId == 0 &&
													<>
														<div className="sub-title">說明</div>
														<div className="content">上圖展示各縣市社會脆弱度綜合指數（Z），依據本站所列之指標項目進行綜合計算而得（詳首頁說明），指數越大表示脆弱度越高。部分年度／縣市因缺乏資料，無法計算。</div>
														<div className="content">顏色辨識：紅色＝高社會脆弱度，藍色＝低社會脆弱度。</div>
													</>
												}
												{
													categoryDescription &&
													categoryDescription.map((category, i) =>
													(
														category.name === currentIndicatorName &&
														<React.Fragment key={i}>
															<div className="title">{category.name}</div>
															<div className="content" dangerouslySetInnerHTML={{ __html: category.description }}></div>
														</React.Fragment>
													)
													)
												}
												{
													(currentIndicatorDescription && currentIndicatorDescription !== '') &&
													<>
														<div className="title">指標定義說明</div>
														<div className="content" dangerouslySetInnerHTML={{ __html: currentIndicatorDescription }}></div>
													</>
												}
											</div>
											{
												// isDataLoaded &&
												<React.Fragment>
													<div className="origin">
														<div className="title">
															<div className="text" style={{ display: 'inline-flex' }} >原始數據
															</div>
															{!showOpt &&
															<div className='hstack gap-16'>
																<CustomDropdown title="下載">
																	{isMemberLogin && <li><button onClick={this.handleClickDownloadCSV}>下載CSV</button></li>}
																	{!isMemberLogin && <li><button onClick={loginRedirect}>登入會員下載CSV</button></li>}
																</CustomDropdown>
																<button className='link' aria-expanded={this.state.tableCollapseToggle ? 'true' : 'false'} onClick={() => this.handleTableCollapseToggle()}></button>
															</div>
															}
														</div>
														{
															csvData &&
															<div className="table" style={this.state.tableCollapseToggle ? { maxHeight: 'unset' } : {}}>
																<SviChartTable csvData={csvData} />
															</div>
														}
														<p className="remark">*標記為非公開資料；-標記為缺資料/無法計算。如有任何問題請<a href="/#contact" target="_blank" rel="noopener noreferrer">聯絡我們</a></p>
														<p className='remark'>*畫面原始值為四捨五入至小數後兩位，完整數值請下載csv</p>
													</div>
												</React.Fragment>
											}
										</>
									}

									{/* 案例故事 */}
									{isDataLoaded &&
									<section id="case-story-section" className="svi-chart__section">
										<div className="d-flex flex-wrap justify-content-between align-items-center">
											<div className="svi-chart__subtitle">案例故事</div>
										</div>
												

										{/* 指標故事輪播 */}
										{this.state.caseStories.length > 0 ? (
											<div className="svi-story-slider">
												<StorySlider key={this.state.caseStorySliderKey} {...storySliderSettings}>
													{this.state.caseStories.map(story => {
														const level = story.IndicatorLevel || 0;
														const tags = [];
														if (story.IndicatorCategoryName) tags.push({ text: story.IndicatorCategoryName, variant: 'outline' });
														if (level >= 2 && story.IndicatorSubcategoryName) tags.push({ text: story.IndicatorSubcategoryName, variant: 'outline' });
														if (level >= 3 && story.IndicatorName) tags.push({ text: story.IndicatorName, variant: 'outline' });
														if (tags.length > 0) tags[tags.length - 1].variant = 'filled';
														const imgPath = story.ImageUrl ? `${sourceHost}/${story.ImageUrl}` : '/banner_img/morakot-en_household-demographics.png';
														return (
															<div className="svi-story-slider__slide" key={story.ID}>
																<Link className="svi-story-card" to={`/evaluation/svi/story/${story.ID}`}>
																	<div className="svi-story-card__image">
																		<img src={imgPath} alt="案例故事文章示意圖" className="svi-story-card__img" />
																	</div>
																	<div className="svi-story-card__body">
																		<div className="svi-story-card__tags">
																			{tags.map((tag, i) => (
																				<span key={i} className={`svi-story-card__tag svi-story-card__tag--${tag.variant}`}>{tag.text}</span>
																			))}
																		</div>
																		<h3 className="svi-story-card__title">{story.Title}</h3>
																																				<p className="svi-story-card__summary">{story.Summary}</p>
																		<time className="svi-story-card__date" dateTime={story.Published}>{story.Published}</time>
																	</div>
																</Link>
															</div>
														);
													})}
												</StorySlider>
											</div>
										) : (
											<p className="text-center" style={{ padding: '40px 0', color: '#888' }}>
												尚無相關案例故事
											</p>
										)}

										{/* 更多按鈕 */}
										<Link to="/evaluation/svi/stories" className="svi-chart__more-btn d-table mx-auto">
											看更多文章
											<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
											<path d="M15.8492 1.00001C15.8492 0.44773 15.4015 1.52364e-05 14.8492 1.49835e-05L5.84917 1.57843e-05C5.29688 1.54471e-05 4.84917 0.447731 4.84917 1.00002C4.84917 1.5523 5.29688 2.00002 5.84917 2.00002L13.8492 2.00002L13.8492 10C13.8492 10.5523 14.2969 11 14.8492 11C15.4015 11 15.8492 10.5523 15.8492 10L15.8492 1.00001ZM0.707031 15.1422L1.41414 15.8493L15.5563 1.70712L14.8492 1.00002L14.1421 0.292909L-7.55191e-05 14.435L0.707031 15.1422Z"/>
											</svg>
										</Link>
									</section>
								}

								</div>
							}
							
						</div>
					</div>
				</div>
				{/* 案例故事浮動按鈕（評估結果出現後就常駐，重新查詢不卸載以免閃爍） */}
				{isDataLoaded &&
					<div className="svi-case-story-anchor">
						<button
							type="button"
							className="svi-case-story-btn"
							data-for="svi-case-story-tooltip"
							data-tip="社會脆弱度（指標項目）如何影響災害衝擊<br />詳見案例故事"
							onClick={() => {
								const el = document.getElementById('case-story-section');
								if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
							}}
						>
							<img src={iconCaseStory} alt="" width="54" height="19" />
							<span>案例故事</span>
						</button>
						<ReactTooltip id="svi-case-story-tooltip" className='tooltip type-text -ch -xs svi-case-story-tooltip' place="left" type="dark" effect="solid" html />
					</div>
				}
				<SocialBlock theme="blue" category="社會脆弱度" action="社會脆弱度指標查詢與展示" />
			</React.Fragment>
		);
	}
}

export default SviChart;
